<template>
  <modal
    v-if="isVisible"
    elem-id="modal_languages_admin"
    modal-size="modal-md"
    :title="t('Adicionar idioma')"
    :show="isVisible"
    @close="closeModal"
    @dismiss="closeModal"
  >
    <template v-if="isVisible">
      <languages-form @save-success="handleSaveSuccess" />
    </template>
  </modal>
</template>

<script setup lang="ts">
import { ref, onMounted, onBeforeUnmount } from 'vue';
import { useI18n } from 'vue-i18n';
import { eventBus } from '../../eventBus';
import { log } from '../../utils/DebugLogger';

const { t } = useI18n();
const isVisible = ref<boolean>(false);

const closeModal = (): void => {
  log('LanguagesModal', 'closeModal', 'Closing');
  isVisible.value = false;
};

const handleSaveSuccess = (): void => {
  log('LanguagesModal', 'handleSaveSuccess', 'Saved');
  closeModal();
  eventBus.emit('languagesAdmin.created');
};

const handleOpen = (): void => {
  log('LanguagesModal', 'handleOpen', 'Opening');
  isVisible.value = true;
};

onMounted(() => {
  eventBus.on('modal.languagesAdmin.open', handleOpen);
});

onBeforeUnmount(() => {
  eventBus.off('modal.languagesAdmin.open', handleOpen);
});
</script>
